import { createFileRoute, useParams } from "@tanstack/react-router";
import { ChallanDetailPage } from "@/components/inventory/ChallanDetailPage";

export const Route = createFileRoute("/admin/_layout/inventory/challans_/$id")({
  component: AdminChallanDetail,
});

function AdminChallanDetail() {
  const { id } = useParams({ from: "/admin/_layout/inventory/challans_/$id" });
  return <ChallanDetailPage challanId={id} />;
}
